//
//
//
//
//
//
//
//
//
//
//
//

import SubMenu from './compoments/subMenu'
import mock from '~/mock'
export default {
  components: {
    SubMenu,
  },
  props: {
    // 首页导航菜单
    menuList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      activeNames: [],
      mock,
      defaultProps: {
        children: 'children',
        label: 'label',
        index: 'id',
      },
    }
  },
  mounted() {
    if (this.menuList) {
      this.getTreeParents(this.menuList)
    }
  },
  methods: {
    onGetMenu(item) {
      this.$emit('getmenu', item)
    },
    //收集所有的id
    getTreeParents(data) {
      data.forEach((item) => {
        if (item.children && item.children.length) {
          this.activeNames.push(item.id)
          this.getTreeParents(item.children)
        }
      })
      return this.activeNames
    },
  },
}
